import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class DateFormatService {
    constructor() {}

    formatDate(date: Date): string {
        if (!date) {
            return '';
        }

        const parsedDate = new Date(date);
        if (isNaN(parsedDate.getTime())) {
            return '';
        }

        const locale = navigator.language || 'de-DE';

        return parsedDate.toLocaleDateString(locale, {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
        });
    }
}
